module.exports = __webpack_public_path__ + "static/media/CB_engagement_17.9c332468.jpg";